// Server-side PDF processing fallback - ENHANCED VERSION
export const processPDFOnServer = async (file) => {
  try {
    console.log("Processing PDF on server:", file.name, "Size:", file.size)

    const formData = new FormData()
    formData.append("file", file)

    console.log("Sending PDF to server for processing...")
    const response = await fetch("/api/process-file", {
      method: "POST",
      body: formData,
    })

    console.log("Server response status:", response.status, response.statusText)

    if (!response.ok) {
      const errorText = await response.text()
      console.error("Server response error:", errorText)
      throw new Error(`Server responded with ${response.status}: ${response.statusText}`)
    }

    const result = await response.json()
    console.log("Server processing result:", result)

    if (result) {
      // Extract the content from the server response
      const extractedContent = result.content || result.text || ""

      console.log("Extracted PDF content length:", extractedContent.length)
      console.log("First 200 chars of content:", extractedContent.substring(0, 200))

      return {
        type: "pdf",
        content: extractedContent,
        name: file.name,
        originalFile: file,
        pageCount: result.pageCount,
        fileSize: result.fileSize || file.size,
        success: true,
      }
    } else {
      throw new Error(result.error || "Server processing failed")
    }
  } catch (error) {
    console.error("Server PDF processing failed:", error)

    return {
      type: "pdf",
      content: `[Server PDF processing failed: ${file.name}]

Error: ${error.message}

File size: ${Math.round(file.size / 1024)} KB

Details:
- The PDF file was uploaded but text extraction failed on the server
- This could be due to:
  * Encrypted or password-protected PDF
  * Corrupted PDF file
  * Unsupported PDF format
  * Server processing limitations

Please try:
1. A different PDF file
2. Converting the PDF to a simpler format
3. Checking if the PDF is password-protected`,
      name: file.name,
      originalFile: file,
      success: false,
    }
  }
}
